
import React from "react";
import { Database } from "lucide-react";

interface DatabaseStatusProps {
  databaseInitialized: boolean;
  lastSaveTime: string | null;
}

const DatabaseStatus: React.FC<DatabaseStatusProps> = ({
  databaseInitialized,
  lastSaveTime
}) => {
  return (
    <div className="mb-4 text-sm text-muted-foreground">
      <p className="font-medium">Wijzigingen worden opgeslagen in de database en zijn direct actief na opslaan.</p>
      {databaseInitialized && (
        <p className="text-green-600 mt-1 flex items-center">
          <Database className="h-3 w-3 mr-1" /> 
          Rechten worden permanent opgeslagen in de database
        </p>
      )}
      {lastSaveTime && (
        <p className="text-green-600 mt-1">
          Laatst opgeslagen: {lastSaveTime}
        </p>
      )}
    </div>
  );
};

export default DatabaseStatus;
